import { useSnackbar } from "notistack";
import { useCallback } from "react";
import type { GlobalNotification } from "../model";

export const useGlobalNotification = () => {
  const { enqueueSnackbar } = useSnackbar();

  const setGlobalNotification = useCallback(
    (globalNotification: GlobalNotification) => {
      enqueueSnackbar(globalNotification.message, {
        variant: globalNotification.variant,
        anchorOrigin: {
          vertical: "bottom",
          horizontal: "center",
        },
        autoHideDuration: globalNotification.autoHide ? 10000 : undefined,
      });
    },
    [enqueueSnackbar],
  );

  return { setGlobalNotification };
};
